<template>
  <div class="login-container">
    <div class="left-side"/>
    <div class="right-side">
      <div class="login-header">
        <img width="500" src="@/assets/image/logo.png">
      </div>
      <div class="login-form">
        <el-form
            ref="loginForm"
            :model="loginForm"
            :rules="rules"
            @submit.native.prevent="handleLogin">
          <el-form-item prop="email">
            <el-input
                v-model="loginForm.email"
                placeholder="Enter your email address"
                prefix-icon="el-icon-user"
                size="large"
                clearable
                @clear="handleClearEmail"/>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
                v-model="loginForm.password"
                type="password"
                placeholder="Enter your password"
                prefix-icon="el-icon-lock"
                size="large"
                show-password
                clearable
                @keyup.enter.native="handleLogin">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
                type="primary"
                size="large"
                class="login-btn"
                :loading="loading"
                @click="handleLogin">
              Log in
            </el-button>
            <p style="text-align: center;">
              Please connect operator if you forget the old password
            </p>
          </el-form-item>
        </el-form>
        <div class="login-footer">
          <el-checkbox v-model="agreeChecked" style="margin-right: 5px;">Agree</el-checkbox>
          <el-link href="/privacy_policy.html" target="_blank">Privacy Policy</el-link> &nbsp;&nbsp;
          <el-link href="/developer_agreement.html" target="_blank">Developer Agreement</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {sspApi} from '@/api';

export default {
  name: "Login",
  data() {
    return {
      loading: false,
      loginForm: {
        email: "",
        password: ""
      },
      agreeChecked: true,
      rules: {
        email: [
          {required: true, message: "This field can't be left blank"},
          {type: "email", message: "Please enter a valid email address"}
        ],
        password: [
          {required: true, message: "This field can't be left blank"}
        ]
      }
    };
  },
  methods: {
    handleClearEmail() {
      this.loginForm.password = "";
    },
    // cooksdk 指纹采集：失败不影响登录主流程
    tryGetDfpFingerPrint() {
      try {
        if (typeof window.dfp === 'undefined') {
          window.console.log('dfp.tryGetFingerPrint skip: window.dfp undefined');
          return;
        }
        if (typeof window.dfp.tryGetFingerPrint !== 'function') {
          window.console.log('dfp.tryGetFingerPrint skip: tryGetFingerPrint not a function', window.dfp);
          return;
        }
        const dfpFingerPrint = window.dfp.tryGetFingerPrint();
        if (dfpFingerPrint) {
          window.console.log('dfp.tryGetFingerPrint success', dfpFingerPrint);
        } else {
          window.console.log('dfp.tryGetFingerPrint empty result', dfpFingerPrint);
        }
      } catch (e) {
        window.console.log('dfp.tryGetFingerPrint error', e);
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (!this.agreeChecked) {
          this.$message.warning("Please review and accept the Privacy Policy and Developer Agreement");
          return;
        }
        if (valid) {
          this.loading = true;
          this.tryGetDfpFingerPrint();
          const loginParams = {
            email: this.loginForm.email,
            password: this.loginForm.password
          };
          sspApi.login({data: loginParams}).then((res) => {
            if (res.code === 200) {
              this.$router.push({name: "report"});
            } else {
              this.$message.error(res.message || "Login failed");
            }
          }).catch(this.$rejectAjaxError()).finally(() => {
            this.loading = false;
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
}

.left-side {
  width: 40%;
  background: url('~@/assets/image/iqiyi.png') center / cover no-repeat;
}

.right-side {
  width: 60%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.login-form {
  width: 420px;
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-btn {
  width: 100%;
}

.login-footer {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-footer >>> .el-checkbox__label {
  color: #444;
}

.el-button {
  border: none;
  background-image: linear-gradient(90deg, #32CCFF 0%, #0CDF62 50%, #0DD35D 100%);
  background-image: -webkit-linear-gradient(left, #32CCFF 0%, #0CDF62 50%, #0DD35D 100%);
}

.el-button:hover {
  border: none;
  background-image: linear-gradient(90deg, #5FD9FF 0%, #28E879 50%, #16E072 100%);
  background-image: -webkit-linear-gradient(left, #5FD9FF 0%, #28E879 50%, #16E072 100%);
}

.login-form >>> .el-input__inner:focus {
  border: 1px solid transparent;
  border-radius: 4px;
  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #32CCFF 0%, #0CDF62 50%, #0DD35D 100%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: none;
  outline: none;
}

.login-form >>> .el-form-item.is-error .el-input__inner {
  border-color: #DCDFE6;
}

.login-form >>> .el-form-item.is-error .el-input__inner:focus {
  border: 1px solid transparent;
  border-radius: 4px;
  background-image: linear-gradient(#fff, #fff), linear-gradient(90deg, #32CCFF 0%, #0CDF62 50%, #0DD35D 100%);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  box-shadow: none;
  outline: none;
}
</style>
